import React from "react";
import PublicArticleList from "./PublicArticleList";

export default function Excerpts() {
  return (
    <PublicArticleList
      kind="excerpt"
      overline="Excerpts"
      title="From The Boggin Chronicles."
      lede="Scenes and passages from the series, shared as they find their final shape. Reader beware: these are working proofs, not the finished spine."
      emptyTitle="No excerpts have been posted yet."
      emptyNote="The manuscript is being guarded by the protagonist. Check back soon."
      dataTestid="public-excerpts"
      baseRoute="/excerpts"
      heroImage={{
        src: "/images/young-boggin-transparent.png",
        alt: "A small orc child peeking from behind a tower of leather-bound tomes, clutching a large book marked with a pentagram.",
        caption: "A young Boggin, midway through an unauthorised research expedition.",
      }}
    />
  );
}
